/**
 * Constantes et définitions d'icônes communes pour les composants
 * Centralise tous les imports FontAwesome et les mappings d'icônes
 */

import { 
  faGlobe, 
  faPerson, 
  faBook, 
  faSpaghettiMonsterFlying, 
  faImage, 
  faFilm,
  faFileLines, 
  faFolder, 
  faCircleXmark,
  faAsterisk,
  faUserPen,
  faFileImport,
  faBoltLightning,
  faTag,
  faPenRuler,
  faCrown,
  faStar,
  faGear,
  faCheck,
  faCube,
  faSpinner,
  faExclamationTriangle,
  faForward,
  faPenToSquare,
  faRepeat,
  faRectangleList,
  faPlaceOfWorship,
  faFile,
  faFontAwesome,
  faCircleInfo
} from '@fortawesome/free-solid-svg-icons';

// Icônes pour les classes d'objets WaItem et pour les icônes d'action
export const CLASS_ICONS = {
  // Icônes Articles et actions
  "World": faGlobe,
  "Person": faPerson,
  "Report": faBook,
  "Species": faSpaghettiMonsterFlying,
  "Beat" : faFilm,
  "Character" :  faPerson,
  "Divinity" :  faBoltLightning,
  "MetaStyle" :  faCircleInfo,
  "Monster" :  faSpaghettiMonsterFlying,
  "Organization" :  faCrown,
  "Church" :  faPlaceOfWorship,
  "Default": faFile,

  // Icônes manuscripts
  "image": faImage, 
  "text": faFileLines, 
  "folder": faFolder, 
  "manuscript": faBook,
  "default": faCircleXmark,

  // Icônes block
  "Statblock": faCube
};

// Icônes pour l'état de brouillon
export const IS_DRAFT = {
  "true": faPenRuler,
  "false": faStar
};

// Icônes pour l'état de travail en cours
export const IS_WIP = {
  "true": faGear,
  "false": faCheck
};

// Icône pour indiquer la présence d'un bloc
export const HAS_BLOCK = faCube;

// Mapping des icônes pour les boutons d'action
export const BUTTON_ICON_MAP = {
  COMPUTE: faForward,
  WRITE: faPenToSquare,
  COPY: faFileImport,
  REWRITE: faRepeat,
  TRANSLATE: faGlobe,
  SUMMARYIZE: faRectangleList,
  FLAG: faFontAwesome
};

// Icônes d'état pour l'interface
export const STATUS_ICONS = {
  LOADING: faSpinner,
  ERROR: faExclamationTriangle,
  SUCCESS: faCheck,
  WARNING: faExclamationTriangle
};
